<div class="flex items-start justify-between gap-4">
  <h2 class="m-0 text-lg font-bold text-midnight">
    {{ isEditMode ? 'Edit signer' : 'Add signer' }}
  </h2>
  <button type="button" mat-dialog-close aria-label="Close dialog">
    <img src="assets/icons/close.svg" alt="Close" class="w-4 h-4" />
  </button>
</div>

<et-journal-signer-form
  [signer]="signer"
  [isLoading]="isLoading()"
  [error]="error()"
  [defaultState]="packet.packetState!"
  [ipAddress]="ipAddress"
  (payloadSubmitted)="onSubmint($event)"
></et-journal-signer-form>
